import React, { useState, useEffect, Fragment, useRef } from "react";
import cellmalogo from "../../assets/images/cellmaflex_logo.png";
import classes from "./css/Header.module.css";
import { getRequest } from "../../api/AxiosAPICall";
import { setSnackbar } from "../commoncomponents/alert/SnackbarAction";
import {
  Drawer,
  Box,
  Grid,
  Stack,
  IconButton,
  Button,
  Toolbar,
  Divider,
  AppBar,
} from "@mui/material";
import {
  Menu as MenuIcon,
  CloseRounded as CloseRoundedIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const SignInHeader = styled(Button)({
  color: "white",
  textTransform: "none",
  backgroundColor: "#1f376e",
  borderRadius: 30,
  width: 90,
  fontSize: 15,
});

export default function Header(props: any) {
  const showHeaderNavigation = props.headernavigation;
  const isLogedIn = props.isLogedIn;
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const { mobileView, drawerOpen } = state;
  const isMounted = useRef<any>();
  const dispatch = useDispatch();
  useEffect(() => {
    let active = true;
    isMounted.current = true;
    const setResponsiveness = () => {
      if (active) {
        return window.innerWidth < 900
          ? setState((prevState) => ({ ...prevState, mobileView: true }))
          : setState((prevState) => ({ ...prevState, mobileView: false }));
      }
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
      active = false;
      isMounted.current = false;
    };
  }, [mobileView]);

  const displayDesktop = () => {
    return (
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {appbarLogo}
        {showHeaderNavigation && isLogedIn && (
          <Toolbar>{getMenuButtons()}</Toolbar>
        )}
      </Box>
    );
  };

  const handleDrawerOpen = () =>
    setState((prevState) => ({ ...prevState, drawerOpen: true }));

  const handleDrawerClose = () =>
    setState((prevState) => ({ ...prevState, drawerOpen: false }));

  let history = useNavigate();
  const singInHandler = (event: any) => {
    event.currentTarget.disabled = true;
    history("/signin");
  };
  const singoutHandler = async (event: any) => {
    event.currentTarget.disabled = true;
    const response = await getRequest("logoutUser", {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
    if (response.toString() === "ERROR") {
      event.currentTarget.disabled = false;
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cellmaflex has encounter an issue. Please contact administrator.",
          "top",
          "center"
        )
      );
    } else if (response.toString() !== "" && typeof response !== "object") {
      event.currentTarget.disabled = false;
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          response.toString(),
          "top",
          "center"
        )
      );
    } else if (response.data !== null) {
      localStorage.removeItem("token");
      localStorage.removeItem("subscriptionDate");
      history("/signin");
    }
  };

  const displayMobile = () => {
    return (
      <Grid
        container
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Drawer
          {...{
            anchor: "right",
            open: drawerOpen,
            onClose: handleDrawerClose,
          }}
        >
          {showHeaderNavigation && isLogedIn && (
            <Box sx={{ padding: "20px 30px" }}>{getDrawerChoices()}</Box>
          )}
        </Drawer>

        <Grid item md={6} sm={6} xs={6}>
          <Link
            to="/"
            onClick={() => {
              if (
                props.cellmaflexUrl !== undefined &&
                props.cellmaflexUrl !== null &&
                props.cellmaflexUrl !== ""
              ) {
                window.location.assign(props.cellmaflexUrl);
              }
            }}
            className={`${jwtToken && classes.logo}`}
          >
            <Stack
              sx={{
                width: { md: "80%", xs: "85%", sm: "47%" },
                backgroundColor: "white",
                marginTop: { md: "5%", xs: "10px", sm: "10px" },
                img: {
                  width: { xs: "100%" },
                  height: { xs: "auto" },
                },
              }}
            >
              <img
                src={cellmalogo}
                alt="cellma-flex-logo"
                className={`${jwtToken && classes.logo}`}
              />
            </Stack>
          </Link>
        </Grid>
        {isLogedIn && (
          <Grid item md={6} sm={6} xs={6}>
            <Stack sx={{ alignItems: "flex-end", marginTop: "3%" }}>
              <IconButton
                aria-label="open drawer"
                edge="end"
                onClick={handleDrawerOpen}
                sx={{ color: "black" }}
              >
                <MenuIcon />
              </IconButton>
            </Stack>
          </Grid>
        )}
      </Grid>
    );
  };

  const getDrawerChoices = () => {
    return (
      <Fragment>
        <CloseRoundedIcon onClick={handleDrawerClose} />
        <Divider />
        <Box className={classes.mobView}>
          <Divider />
          {(jwtToken === "" || jwtToken === undefined) && (
            <Stack
              spacing={2}
              direction="column"
              className={classes.navLinkDrawer}
            >
              <SignInHeader
                variant="contained"
                onClick={singInHandler}
                sx={{
                  width: { md: "100% !important" },
                  fontSize: "15px !important",
                  borderRadius: "3px !important",
                  backgroundColor: "#117CB1 !important",
                  color: "#FFFFFF !important",
                  "&:hover": { backgroundColor: "#1976d2 !important" },
                }}
              >
                Sign in
              </SignInHeader>
            </Stack>
          )}

          {jwtToken && (
            <Stack
              spacing={2}
              direction="column"
              className={classes.navLinkDrawer}
            >
              <SignInHeader
                variant="contained"
                onClick={singoutHandler}
                sx={{
                  width: { xs: "93px", md: "100% !important" },
                  fontSize: "15px !important",
                  borderRadius: "3px !important",
                  backgroundColor: "#117CB1 !important",
                  color: "#FFFFFF !important",
                  "&:hover": { backgroundColor: "#1976d2 !important" },
                }}
              >
                Sign out
              </SignInHeader>
            </Stack>
          )}
        </Box>
      </Fragment>
    );
  };

  const appbarLogo = (
    <Box className={classes.navbarLogoBox}>
      <Link
        to="/"
        onClick={() => {
          if (
            props.cellmaflexUrl !== undefined &&
            props.cellmaflexUrl !== null &&
            props.cellmaflexUrl !== ""
          ) {
            window.location.assign(props.cellmaflexUrl);
          }
        }}
        className={`${jwtToken && classes.logo}`}
      >
        <Stack
          sx={{
            width: { md: "80%", xs: "85%", sm: "47%" },
            backgroundColor: "white",
            marginTop: { md: "5%", xs: "10px", sm: "10px" },
          }}
        >
          <img
            src={cellmalogo}
            alt="cellma-flex-logo"
            className={`${jwtToken && classes.logo}`}
          />
        </Stack>
      </Link>
    </Box>
  );

  const getMenuButtons = () => {
    return (
      <React.Fragment>
        <Toolbar>
          {(jwtToken === "" || jwtToken === undefined) && (
            <Stack spacing={2} direction="row">
              <SignInHeader
                variant="contained"
                onClick={singInHandler}
                sx={{
                  width: { md: "100% !important" },
                  fontSize: "15px !important",
                  borderRadius: "3px !important",
                  backgroundColor: "#117CB1 !important",
                  color: "#FFFFFF !important",
                  "&:hover": { backgroundColor: "#1976d2 !important" },
                }}
              >
                Sign in
              </SignInHeader>
            </Stack>
          )}
          {jwtToken && (
            <Stack spacing={2} direction="row">
              <SignInHeader
                variant="contained"
                onClick={singoutHandler}
                sx={{
                  width: { md: "100% !important" },
                  fontSize: "15px !important",
                  borderRadius: "3px !important",
                  backgroundColor: "#117CB1 !important",
                  color: "#FFFFFF !important",
                  "&:hover": { backgroundColor: "#1976d2 !important" },
                }}
              >
                Sign out
              </SignInHeader>
            </Stack>
          )}
        </Toolbar>
      </React.Fragment>
    );
  };

  return (
    <header>
      <AppBar
        sx={{
          paddingLeft: { xs: "5%", md: "2%", lg: "7%" },
          paddingRight: { xs: "5%", md: "0%", lg: "4%" },
          backgroundColor: "white",
        }}
      >
        {mobileView ? displayMobile() : displayDesktop()}
      </AppBar>
    </header>
  );
}
